import React from "react";
import { ReactComponent as ZediLogo } from "../assets/ZEDIPASS-LOGO-LOCKUP.svg";

// The Logo will inherit color from parent via currentColor (text-* classes)
const Logo = ({ className = "h-8 w-auto text-black dark:text-white" }) => {
  return <ZediLogo className={className} />;
};

export default Logo;